import { createGtm } from '@gtm-support/vue-gtm';

export default defineNuxtPlugin((nuxtApp) => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public: { isDev, gtmId },
  } = useRuntimeConfig();
  nuxtApp.vueApp.use(
    createGtm({
      id: gtmId,
      defer: false,
      debug: false, // isDev
      //   enabled: !isDev,
      loadScript: true,
      trackOnNextTick: false,
    }),
  );
});
